import {
  AssetIssues,
  CustomAttributes,
  IOptions,
  // RoomLevelIssuePhotos,
  RoomLevelIssues
} from 'types/room';
import React from 'react';
import { compact, uniq } from 'lodash';
import { Button, Link, Stack, Typography } from '@mui/material';
import { IconCollapse } from '../elements/icons/IconCollapse';
import { TextEllipsis } from '../elements/TextEllipsis';
import { Image } from '../elements/Image';
import { Report } from 'types/report';
import dayjs from 'dayjs';
import { formatAppDateTime } from 'utils/dateFormat';
import { ConfirmActionDialog } from '../elements/ConfirmActionDialog';
import { PhotoPreviewGroup } from '../elements/PhotoPreviewThumbnail';
import { convertFileToStorage } from 'utils/convertData';
type RenderDataComplianceIssueProps = {
  indexActive?: number;
  dataTable: AssetIssues[];
  onViewIssues: (value: AssetIssues) => void;
  onArchive?: (value: AssetIssues) => void;
  onPreviewPdf?: (value: AssetIssues) => void;
  onCollapse?: ({ value, indexRow }: { value: AssetIssues; indexRow: number }) => void;
  onDeleteAsset?: (id: AssetIssues) => void;
  onCreateNewIssue: (value: AssetIssues) => void;
  onGenerateSingleAsset?: (value: AssetIssues) => Promise<void>;
  onClickRoom?: (value?: { key: string; value: string; label: string; level?: number }) => void;
  keySearch?: { key: string; value: string; label: string; level?: number }[];
  readOnly?: boolean;
  isCanAction?: boolean;
};
export const renderDataComplianceIssue = ({
  indexActive,
  dataTable,
  keySearch,
  onViewIssues,
  onArchive,
  onCollapse,
  onPreviewPdf,
  onCreateNewIssue,
  onClickRoom,
  readOnly,
  isCanAction,
  onGenerateSingleAsset
}: RenderDataComplianceIssueProps) => {
  const checkIsFilter = (key: string) => {
    return !!keySearch?.find((item) => item.key === key);
  };
  return dataTable?.map((data, index) => {
    const tags = compact(
      data.tags.map((item) => {
        if (item.submittedPhotoId) {
          return item.submittedPhoto.type;
        }
        if (item.additionalStructurePhotoId) {
          return item.additionalStructurePhoto.additionalStructure.type;
        }
      })
    );
    const isHasIssueIsNotRepaired = data.issueReports.some((issue) => issue.status === 'ACTIVE');
    return {
      name: {
        value: (
          <TextEllipsis
            text={data.name}
            width={'95%'}
            onClick={() => {
              {
                data.name &&
                  !readOnly &&
                  onClickRoom?.({
                    value: data.name,
                    label: data.name,
                    key: 'name'
                  });
              }
            }}
            active={checkIsFilter('name')}
          />
        )
      },
      type: {
        value: (
          <TextEllipsis
            text={data?.type?.name}
            width={'95%'}
            onClick={() => {
              data?.type?.name &&
                !readOnly &&
                onClickRoom?.({
                  value: data.type?.id.toString(),
                  label: data.type?.name,
                  key: 'typeId'
                });
            }}
            styles={{
              fontWeight: checkIsFilter('typeId') ? 700 : 400,
              backgroundColor: checkIsFilter('typeId') ? 'rgba(0,0,0,0.2)' : 'unset'
            }}
          />
        )
      },
      ...(readOnly
        ? {
            codition: {
              value: <TextEllipsis text={data?.condition} width={'95%'} />
            }
          }
        : {}),
      hasIssue: {
        value: (
          <TextEllipsis
            styles={{
              color:
                data?.issueReports?.length > 0 && isHasIssueIsNotRepaired ? '#DD0808' : '#23C33B'
            }}
            onClick={() => {
              !readOnly &&
                onClickRoom?.({
                  value: data.issueReports.length > 0 && isHasIssueIsNotRepaired ? 'true' : 'false',
                  label: data.issueReports.length > 0 && isHasIssueIsNotRepaired ? 'Yes' : 'No',
                  key: 'hasIssue'
                });
            }}
            active={checkIsFilter('hasIssue')}
            text={data?.issueReports?.length > 0 && isHasIssueIsNotRepaired ? 'Yes' : 'No'}
            width={'95%'}
            inputStyle={{
              color: data.issueReports.length > 0 && isHasIssueIsNotRepaired ? '#DD0808' : '#23C33B'
            }}
          />
        )
      },
      model: {
        value: (
          <TextEllipsis
            text={data.model.name}
            width={'95%'}
            onClick={() => {
              !readOnly &&
                onClickRoom?.({
                  value: data.model.id.toString(),
                  label: data.model.name,
                  key: 'modelId'
                });
            }}
            active={checkIsFilter('modelId')}
          />
        )
      },
      validated: {
        value: (
          <TextEllipsis
            text={data.validated ? 'Yes' : 'No'}
            width={'95%'}
            onClick={() => {
              !readOnly &&
                onClickRoom?.({
                  value: data.validated ? 'true' : 'false',
                  label: data.validated ? 'Yes' : 'No',
                  key: 'validated'
                });
            }}
            active={checkIsFilter('validated')}
            inputStyle={{ color: data.validated ? '#4CAF50' : '#F44336' }}
          />
        )
      },
      tag: {
        value: <Typography>{uniq(tags).join(', ')}</Typography>
      },
      createdAt: {
        value: (
          <TextEllipsis text={dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      updatedAt: {
        value: (
          <TextEllipsis text={dayjs(data.updatedAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      photo: {
        value: data?.photos?.length > 0 && (
          <Image
            url={{
              url: data.photos[0].url,
              type: data.photos[0].storage?.type ?? 'image/jpeg'
            }}
            width={50}
            height={50}
          />
        )
      },
      attributes: {
        value: onPreviewPdf && (
          <Button
            onClick={() => onCollapse && onCollapse({ value: data, indexRow: index })}
            style={{ flexDirection: 'row', gap: '10px', width: '100%' }}>
            <IconCollapse color={'#226AAA'} direction={indexActive === index ? 'up' : 'down'} />
            <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
              {indexActive === index ? 'Collapse' : 'Expand'}
            </Typography>
          </Button>
        )
      },
      preview: {
        value: onGenerateSingleAsset && (
          <Button onClick={() => onGenerateSingleAsset(data)}>
            <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
              Single Asset PDF
            </Typography>
          </Button>
        )
      },
      action: {
        value: onPreviewPdf && isCanAction && (
          <Stack style={{ flexDirection: 'row', alignItems: 'flex-start' }}>
            <Stack style={{ alignItems: 'flex-start', minWidth: '94px' }}>
              <Button
                onClick={() => {
                  onCreateNewIssue(data);
                }}>
                <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                  Create New Issue
                </Typography>
              </Button>
              {data.issueReports.length > 0 && (
                <Button
                  onClick={() => {
                    onViewIssues(data);
                  }}>
                  <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                    {isHasIssueIsNotRepaired
                      ? `Current Issue${data.issueReports.length > 1 ? 's' : ''}`
                      : 'Nonactive Issue'}
                  </Typography>
                </Button>
              )}
              {onArchive && (
                <ConfirmActionDialog
                  title={`Confirm ${data.archivedAt ? 'active' : 'archive'} this assets`}
                  description={`Are you sure to ${data.archivedAt ? 'active' : 'archive'} this assets?`}
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => {
                    onArchive(data);
                  }}>
                  <Button>
                    <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                      {data.archivedAt ? 'Active' : 'Archive'}
                    </Typography>
                  </Button>
                </ConfirmActionDialog>
              )}
            </Stack>
            {/*{onDeleteAsset && (*/}
            {/*  <IconButton*/}
            {/*    onClick={() => {*/}
            {/*      onDeleteAsset(data);*/}
            {/*    }}>*/}
            {/*    <img alt={'icon-user'} src={'/icons/icon_delete.svg'} width={24} />*/}
            {/*  </IconButton>*/}
            {/*)}*/}
          </Stack>
        )
      }
    };
  });
};

export const renderRoomLevelIssues = ({
  dataTable,
  navigateDetail,
  optionsLargestInTable,
  getLabelField,
  isCanAction,
  // onViewPhotos,
  onArchive
}: {
  dataTable: RoomLevelIssues[];
  navigateDetail?: (data: RoomLevelIssues) => void;
  optionsLargestInTable: IOptions[];
  getLabelField: (type: string) => string;
  isCanAction?: boolean;
  // onViewPhotos?: (photos: RoomLevelIssuePhotos[]) => void;
  onArchive?: (data: RoomLevelIssues) => void;
}) => {
  const formatActionByDisplay = (issue: RoomLevelIssues) => {
    const raw = issue.actionBy?.trim();
    if (!raw) return '';
    if (raw.startsWith('other_')) return raw.slice('other_'.length);
    return raw;
  };
  return dataTable?.map((data) => {
    const roomLevelIssuesOptions: Record<string, { value: JSX.Element }> = {};
    optionsLargestInTable.forEach((issueOption) => {
      roomLevelIssuesOptions[`${getLabelField(issueOption?.type)}`] = {
        value: <></>
      };
    });
    data.options.forEach((issueOption) => {
      roomLevelIssuesOptions[`${getLabelField(issueOption?.type)}`] = {
        value: <TextEllipsis text={issueOption?.value} width={'95%'} />
      };
    });
    return {
      ...roomLevelIssuesOptions,
      description: {
        value: <TextEllipsis text={data?.description} width={'95%'} />
      },
      validated: {
        value: (
          <TextEllipsis
            text={data?.validated ? 'Yes' : 'No'}
            width={'95%'}
            inputStyle={{ color: data.validated ? '#4CAF50' : '#F44336' }}
          />
        )
      },
      actionBy: {
        value: <TextEllipsis text={formatActionByDisplay(data)} width={'95%'} />
      },
      actionByDate: {
        value: (
          <TextEllipsis
            text={
              data.actionByDate && dayjs(data.actionByDate).isValid()
                ? dayjs(data.actionByDate).format('YYYY-MM-DD')
                : ''
            }
            width={'95%'}
          />
        )
      },
      status: {
        value: (
          <TextEllipsis
            text={
              data?.status === 'RESOLVED'
                ? 'Resolved'
                : data?.status === 'ACTIVE'
                  ? 'Open'
                  : (data?.status ?? '')
            }
            width={'95%'}
          />
        )
      },
      dateResolved: {
        value: (
          <TextEllipsis
            text={data.resolutionDate ? dayjs(data.resolutionDate).format('YYYY-MM-DD HH:mm') : ''}
            width={'95%'}
          />
        )
      },
      createdAt: {
        value: (
          <TextEllipsis text={dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      updatedAt: {
        value: (
          <TextEllipsis text={dayjs(data.updatedAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      photo: {
        value:
          data.roomLevelIssuePhotos?.length > 0 ? (
            <PhotoPreviewGroup
              photos={data.roomLevelIssuePhotos.map((p, i) => ({
                src: p.url || convertFileToStorage('inspections', p.photo),
                alt: `issue-photo-${i}`,
                key: p.id ?? i
              }))}
              thumbnailWidth={50}
              thumbnailHeight={50}
            />
          ) : (
            <></>
          )
      },
      action: {
        value:
          isCanAction && (onArchive || navigateDetail) ? (
            <Stack gap={1} alignItems="flex-start">
              {onArchive && (
                <ConfirmActionDialog
                  title={`Confirm ${data.archivedAt ? 'unarchive' : 'archive'} this location level issue?`}
                  description={`Are you sure you want to ${data.archivedAt ? 'unarchive' : 'archive'} this level issue?`}
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => onArchive(data)}>
                  <span>
                    <Button
                      variant="text"
                      disableRipple
                      sx={{
                        minWidth: 0,
                        p: 0,
                        color: '#226AAA',
                        fontSize: '14px',
                        fontWeight: 700,
                        textTransform: 'none'
                      }}>
                      {data.archivedAt ? 'Unarchive' : 'Archive'}
                    </Button>
                  </span>
                </ConfirmActionDialog>
              )}
              {navigateDetail && (
                <Link
                  style={{ fontWeight: 600, cursor: 'pointer' }}
                  onClick={() => navigateDetail(data)}>
                  View / Edit
                </Link>
              )}
            </Stack>
          ) : (
            <></>
          )
      }
    };
  });
};
export const renderCustomAttributes = ({ dataTable }: { dataTable: CustomAttributes[] }) => {
  return dataTable?.map((data) => {
    return {
      type: {
        value: <TextEllipsis text={data?.field} width={'95%'} />
      },
      description: {
        value: <TextEllipsis text={data?.description} width={'95%'} />
      },
      photo: {
        value: (
          <Stack flexDirection={'row'} gap={1.25} alignItems={'center'}>
            {data.url && (
              <Image
                url={{ url: data.url, type: data.photo?.type ?? 'image/jpeg' }}
                width={50}
                height={50}
              />
            )}
          </Stack>
        )
      }
    };
  });
};

export const renderTableIssueManagement = ({
  dataTable,
  onView,
  onArchive,
  getLabelField,
  optionsLargestInTable
}: {
  dataTable: Report[];
  onView: (value: Report) => void;
  onArchive?: (value: Report) => void;
  optionsLargestInTable: IOptions[];
  getLabelField: (type: string) => string;
}) => {
  return dataTable.map((data) => {
    const reportIssuesOptions: Record<string, { value: JSX.Element }> = {};
    optionsLargestInTable.forEach((reportOption) => {
      reportIssuesOptions[`${getLabelField(reportOption?.type)}`] = {
        value: <></>
      };
    });
    data.options.forEach((reportOption) => {
      reportIssuesOptions[`${getLabelField(reportOption?.type)}`] = {
        value: <TextEllipsis text={reportOption?.value} width={'95%'} />
      };
    });
    return {
      equipmentId: {
        value: <TextEllipsis text={data?.equipmentId} width={'95%'} />
      },
      ...reportIssuesOptions,
      actionBy: {
        value: <TextEllipsis text={data?.actionBy?.replace('other_', '')} width={'95%'} />
      },
      actionByDate: {
        value: (
          <TextEllipsis
            text={data?.actionByDate ? dayjs(data?.actionByDate).format('YYYY-MM-DD') : ''}
            width={'95%'}
          />
        )
      },
      description: {
        value: (
          <Typography whiteSpace={'pre-line'} width={'90%'}>
            {data?.description}
          </Typography>
        )
      },
      resolutionDate: {
        value: data?.resolutionDate ? (
          <TextEllipsis text={formatAppDateTime(data?.resolutionDate)} width={'95%'} />
        ) : null
      },
      status: {
        value: (
          <TextEllipsis
            text={
              data?.status === 'RESOLVED'
                ? 'Resolved'
                : data?.status === 'ACTIVE'
                  ? 'Open'
                  : (data?.status ?? '')
            }
            width={'95%'}
          />
        )
      },
      createdAt: {
        value: (
          <TextEllipsis text={dayjs(data.createdAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      updatedAt: {
        value: (
          <TextEllipsis text={dayjs(data.updatedAt).format('YYYY-MM-DD HH:mm')} width={'95%'} />
        )
      },
      photos: {
        value: data?.issueReportPhotos.length > 0 && (
          <Stack flexDirection={'row'} gap={2} alignItems={'center'}>
            <img
              style={{ width: '50px', height: '50px', borderRadius: '5px' }}
              alt={'image'}
              src={data.issueReportPhotos[0].url}
            />
          </Stack>
        )
      },
      action: {
        value: (
          <Stack style={{ alignItems: 'flex-start', gap: 10 }}>
            {onArchive && (
              <ConfirmActionDialog
                title={`Confirm ${data.archivedAt ? 'active' : 'archive'} this issue`}
                description={`Are you sure to ${data.archivedAt ? 'active' : 'archive'} this issue?`}
                okText="Yes"
                cancelText="No"
                onConfirm={() => {
                  onArchive(data);
                }}>
                <Button>
                  <Typography style={{ color: '#226AAA', fontSize: '14px', fontWeight: 700 }}>
                    {data.archivedAt ? 'Active' : 'Archive'}
                  </Typography>
                </Button>
              </ConfirmActionDialog>
            )}
            <Link style={{ fontWeight: 600, cursor: 'pointer' }} onClick={() => onView(data)}>
              View / Edit
            </Link>
          </Stack>
        )
      }
    };
  });
};
